export default __webpack_public_path__ + "static/media/filter.85eb8a04.svg";